import PreorderPage from './modules/preorder/PreorderPage.svelte';

const app = new PreorderPage({
  target: document.getElementById('preorder-page'),
  props: {
    pageConfig: window['pageConfig'],
  },
});

export default app;
